import { Container } from './styles';
import Illustration from '../../assets/ai_developer.jpg';
import pytorch from '../../assets/pytorch.svg';
import tensorflow from '../../assets/tensorflow.svg';
import python from '../../assets/python.svg';
import docker from '../../assets/docker.svg';
import pl from '../../assets/pl_logo.svg';
import js from '../../assets/js.svg';
import django from '../../assets/django.svg';
import huggingface from '../../assets/huggingface.svg';
import numpy from '../../assets/numpy.svg';
import opencv from '../../assets/opencv.svg';
import sklearn from '../../assets/sklearn.png';
import git from '../../assets/git.svg';
import ScrollAnimation from 'react-animate-on-scroll';
import { StunningIconWrapper } from '../Shared/StunningIconWrapper';

const images = [
	pytorch,
	tensorflow,
	python,
	docker,
	pl,
	js,
	django,
	huggingface,
	numpy,
	opencv,
	sklearn,
	git,
];

const imageAlts = [
	'PyTorch logo',
	'TensorFlow logo',
	'Python logo',
	'Docker logo',
	'PyTorch Lightning logo',
	'JavaScript logo',
	'Django logo',
	'Hugging Face logo',
	'NumPy logo',
	'OpenCV logo',
	'Scikit-learn logo',
	'Git logo',
];

const skillPlatforms = [
	'pytorch',
	'tensorflow',
	'python',
	'docker',
	'lightning',
	'nodejs',
	'django',
	'huggingface',
	'numpy',
	'opencv',
	'sklearn',
	'git',
];

export function About() {
	return (
		<Container id='about'>
			<div className='about-text'>
				<ScrollAnimation animateIn='fadeInLeft'>
					<h2>Info</h2>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInLeft' delay={0.1 * 1000}>
					<p>
						Hi! I'm Bekhzod, a Principal AI Engineer with a PhD in Computer Science & Engineering, 
						based in Seoul, South Korea with permanent residence (F5-15 Visa). 
						I specialize in transforming cutting-edge AI research into production-grade solutions that 
						deliver measurable impact. With expertise spanning computer vision, NLP, and generative AI, 
						I've led teams in deploying AI systems serving thousands of users daily—from cervical cancer 
						detection platforms to multilingual voice assistants. My passion lies in bridging the gap between 
						academic innovation and real-world applications that genuinely improve people's lives.
					</p>
				</ScrollAnimation>
				<ScrollAnimation animateIn='fadeInLeft' delay={0.11 * 1000}>
					<h3>Here are my main skills:</h3>
				</ScrollAnimation>

				<div
					style={{
						display: 'flex',
						flexWrap: 'wrap',
						gap: '10px',
						marginTop: '20px',
					}}
				>
					{images.map((item, index) => (
						<ScrollAnimation
							key={index}
							animateIn='fadeInLeft'
							delay={index * 0.1 * 1000}
						>
							<StunningIconWrapper
								type="skill"
								platform={skillPlatforms[index]}
								delay={index}
							>
								<img
									style={{
										width: '100%',
										height: '100%',
										objectFit: 'contain',
									}}
									src={item}
									alt={imageAlts[index]}
								/>
							</StunningIconWrapper>
						</ScrollAnimation>
					))}
				</div>
			</div>
			<div
				style={{
					flex: 1,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
				className='about-image'
			>
				<ScrollAnimation animateIn='fadeInRight' delay={0.5 * 1000}>
					<img
						style={{
							borderRadius: '15px',
						}}
						src={Illustration}
						alt='Illustration'
					/>
				</ScrollAnimation>
			</div>
		</Container>
	);
}
